import { render, staticRenderFns } from "./PedidoDeCompraAprovacaoCoordenadoresView.vue?vue&type=template&id=9f0eff56&scoped=true"
import script from "./PedidoDeCompraAprovacaoCoordenadoresView.vue?vue&type=script&setup=true&lang=js"
export * from "./PedidoDeCompraAprovacaoCoordenadoresView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PedidoDeCompraAprovacaoCoordenadoresView.vue?vue&type=style&index=0&id=9f0eff56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f0eff56",
  null
  
)

export default component.exports